export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7725.a5ca7691.jpg";